import moment from 'moment'
export default (api) => {
  api.series = {
    public: {
      hot: () => api.request({
        url: `/api/series/web/hot`,
        type: 'get',
      }),
      view: (id) => {
        return api.request({
          url: `/api/series/views/${id}`,
          type: 'post',
          tokenTypeLimit: 'member',
        })
      },
      read: (id, ep = null) => {
        let params = {}
        if(ep) params.ep = ep
        params.is_smil = true
        return api.request({
          url: `/api/series/${id}`,
          type: 'get',
          tokenTypeLimit: 'member',
          params,
        })
      },
      recommend: (id) => api.request({
        url: `/api/series/recommend/${id}`,
        type: 'get',
      }),
      getEpsByGroupId: (id) => api.request({
        url: `/api/series/${id}/ep`,
        type: 'get',
      }),
    },
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/series/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/series/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/series`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/series/${id}/all`,
        type: 'put',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/series/${id}/update`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/series/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/series/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/series/batch`,
        type: 'delete',
        params,
      }),
      // SeriesAdmin - 影集 - 取得群組所有ep
      getEpsByGroupId: (id) => api.request({
        url: `/api/admin/series/${id}/ep`,
        type: 'get',
      }),
      // SeriesAdmin - 影集 - 群組更新ep
      updateEpsInGroup: (id, params) => api.request({
        url: `/api/admin/series/set-group-ep/${id}`,
        type: 'post',
        params,
      }),
      // SeriesAdmin - 影集 - 設定集數年份群組(編輯年份內的所有群組使用)
      setupGroupOfSeries: (series_id, params) => api.request({
        url: `/api/admin/series/set-year-group/${series_id}`,
        type: 'post',
        params,
      }),
      // SeriesAdmin - 影集 - 刪除年份群組
      deleteGroupOfSeries: (yearId) => api.request({
        url: `/api/admin/series/del-year-group/${yearId}`,
        type: 'delete',
      }),
    },
  }
  api.seriesCategory = {
    public: {
      getDescendants: (id) => api.request({
        url: `/api/series-category/descendants/${id}`,
        type: 'get',
      }),
      getSeriesLayer1: () => api.request({
        url: `/api/series-category/all`,
        type: 'get',
      }),
      getSeriesLayer2: (id) => api.request({
        url: `/api/series-category/descendants/${id}`,
        type: 'get',
      }),
    },
    admin: {
      tree: () => api.request({
        url: `/api/admin/series-category/tree`,
        type: 'get',
      }),
      index: (params = null) => api.request({
        url: `/api/admin/series-category/roots`,
        type: 'get',
        params,
      }),
      getDescendantsAsTree: (id) => api.request({
        url: `/api/admin/series-category/descendants-tree/${id}`,
        type: 'get',
      }),
      getDescendants: (id) => api.request({
        url: `/api/admin/series-category/descendants/${id}`,
        type: 'get',
      }),
      readRoot: (id) => api.request({
        url: `/api/admin/series-category/root/${id}`,
        type: 'get',
      }),
      create: (id, params = {}) => api.request({
        url: `/api/admin/series-category/${id}`,
        type: 'post',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/series-category/${id}`,
        type: 'put',
        params,
      }),
      updateStatus: (id, params = {}) => api.request({
        url: `/api/admin/series-category/status/${id}`,
        type: 'put',
        params,
      }),
      createRoot: (params = {}) => api.request({
        url: `/api/admin/series-category/root`,
        type: 'post',
        params,
      }),
      rootUpdateAll: (id, params = {}) => api.request({
        url: `/api/admin/series-category/root/${id}/all`,
        type: 'put',
        params,
      }),
      deleteRoot: (id) => api.request({
        url: `/api/admin/series-category/root/${id}`,
        type: 'delete',
      }),
      delete: (id) => api.request({
        url: `/api/admin/series-category/${id}`,
        type: 'delete',
      }),
      moveInsideApi: (moveId, targetId) => api.request({
        url: `/api/admin/series-category/move-first`,
        type: 'put',
        params: {
          move_id: moveId,
          target_id: targetId,
        },
      }),
      moveAfterApi: (moveId, targetId) => api.request({
        url: `/api/admin/series-category/move-after`,
        type: 'put',
        params: {
          move_id: moveId,
          target_id: targetId,
        },
      }),
    },
  }

  api.video = {
    public: {
      addBonus: (params) => api.request({
        url: `/api/video/add-bonus`,
        tokenTypeLimit: 'member',
        type: 'post',
        params,
      }),
      read: (id) => api.request({
        url: `/api/video/${id}`,
        tokenTypeLimit: 'member',
        type: 'get',
        params: {is_smil: true}
      }),
      updateWatchLog: (params = {}) => api.request({
        url: `/api/video/watch_history`,
        type: 'post',
        params,
      }),
      // 影集影片 - 索引
      seriesVideoIndex: (params) => api.request({
        url: `/api/video/index`,
        type: 'get',
        params,
      }),
      // 影集 - 索引
      seriesIndex: (params) => api.request({
        url: `/api/video/index/series`,
        type: 'get',
        params,
      }),
    },
    admin: {
      download: (id) => api.request({
        url: `/api/admin/video/${id}/download`,
        type: 'post',
        responseType: 'blob',
      }),
      clips: (id, params = null) => api.request({
        url: `/api/admin/video/${id}/clips`,
        type: 'put',
        params,
      }),
      getByIds: (params = null) => api.request({
        url: `/api/admin/video/ids`,
        type: 'get',
        params,
      }),
      youtube: (params = null) => api.request({
        url: `/api/admin/video/youtube`,
        type: 'put',
        params,
      }),
      index: (params = null) => api.request({
        url: `/api/admin/video/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/video/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/video`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/video/${id}/all`,
        type: 'put',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/video/${id}/update`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/video/batch`,
        type: 'put',
        params,
      }),
      removeRssFile: (id, s3Path) => api.request({
        url: `/api/admin/video/rss-file/${id}`,
        type: 'delete',
        params: { s3Path }
      }),
      delete: (id) => api.request({
        url: `/api/admin/video/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/video/batch`,
        type: 'delete',
        params,
      }),
      getS3Credential: () => api.request({
        url: `/api/admin/video/credential`,
        type: 'post',
      }),
      executeDatasyncTask: (params) => api.request({
        url: `/api/admin/video/execute-task`,
        type: 'post',
        params,
      }),
      getProcessing: (id) => api.request({
        url: `/api/admin/video/processing/${id}`,
        type: 'get',
      }),
      updateVideoStreaming: (id) => api.request({
        url: `/api/admin/video/streaming/${id}`,
        type: 'put',
      }),
    },
  }

  api.program = {
    public: {
      index: (params = null) => api.request({
        url: `/api/program/index`,
        type: 'get',
        params,
      }),
    },
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/program/index`,
        type: 'get',
        params,
      }),
      create: (params= {}) => api.request({
        url: `/api/admin/program`,
        type: 'post',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/program/${id}`,
        type: 'get',
      }),
      customSync: (start, end) => {
        const diff = Math.abs(moment(end).diff(start, 'days'))+1
        return api.request({
          url: `/api/admin/program/custom-sync`,
          type: 'post',
          params: {
            date: start,
            day: diff,
          },
        })
      },
      sync: (params = null) => api.request({
        url: `/api/admin/program/sync`,
        type: 'post',
        params,
      }),
      update: (id, params) => api.request({
        url: `/api/admin/program/${id}/update`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/program/${id}`,
        type: 'delete',
      }),
    },
  }

  api.programConfig = {
    public: {
    },
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/program-config/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/program-config/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/program-config`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/program-config/${id}/all`,
        type: 'put',
        params,
      }),
      update: (id, params = {}) => api.request({
        url: `/api/admin/program-config/${id}/update`,
        type: 'put',
        params,
      }),
      batch: (params) => api.request({
        url: `/api/admin/program-config/batch`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/program-config/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/program-config/batch`,
        type: 'delete',
        params,
      }),
    },
  }

  api.video_preview = {
    admin: {
      index: (params = null) => api.request({
        url: `/api/admin/video-preview/index`,
        type: 'get',
        params,
      }),
      read: (id) => api.request({
        url: `/api/admin/video-preview/${id}`,
        type: 'get',
      }),
      create: (params = {}) => api.request({
        url: `/api/admin/video-preview`,
        type: 'post',
        params,
      }),
      updateAll: (id, params = {}) => api.request({
        url: `/api/admin/video-preview/${id}/all`,
        type: 'put',
        params,
      }),
      delete: (id) => api.request({
        url: `/api/admin/video-preview/${id}`,
        type: 'delete',
      }),
      batchDelete: (params) => api.request({
        url: `/api/admin/video-preview/batch`,
        type: 'delete',
        params,
      }),
    },
  }
}
